import { render } from "./App.vue?vue&type=template&id=15a45591&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=15a45591&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4050182976/src/directories.medicalprosoftware.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a45591"]])

export default __exports__